export default __webpack_public_path__ + "8396c33f305d0d2784207f6b2545347b.png";